
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function InvoiceSettingsCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Invoice Settings</CardTitle>
        <CardDescription>
          Configure your invoice settings in each project's settings page under the "Invoice Settings" tab.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-4">
          The invoice system pulls client details and payment information from your project settings. To customize them:
        </p>
        
        <ol className="list-decimal pl-5 space-y-2 text-sm">
          <li>Go to Projects page</li>
          <li>Select a project</li>
          <li>Navigate to the "Invoice Settings" tab</li>
          <li>Add client name, email, address, and payment details</li>
        </ol>
        
        <Button 
          className="w-full mt-6" 
          variant="outline"
          onClick={() => window.location.href = "/projects"}
        >
          Go to Projects
        </Button>
      </CardContent>
    </Card>
  );
}
